export default __webpack_public_path__ + "static/media/price-low.5cfc1331.svg";